module.exports = __webpack_public_path__ + "static/media/Sealeo_gaussian2.14cb3e8c.png";